<template>
  <div class="paper-choice-set-teacher-edit" v-loading="loading" element-loading-text="加载中...">
    <template v-if="teacherInfo">
      <div class="cont-wrap">
        <AppScrollbar style="height: 100%;">
          <div class="cont">
            <div class="form-wrap">
              <el-form size="mini" label-width="100px" label-suffix="：">
                <el-form-item label="教学点">{{ teacherInfo.site }}</el-form-item>
                <el-form-item label="姓名">{{ teacherInfo.trueName }}</el-form-item>
                <el-form-item label="登录名">{{ teacherInfo.loginId }}</el-form-item>
                <el-form-item label="职称">{{ teacherInfo.title }}</el-form-item>
                <el-form-item label="手机号码">{{ teacherInfo.phone }}</el-form-item>
                <el-form-item label="电子邮箱">{{ teacherInfo.email }}</el-form-item>
              </el-form>
            </div>
            <div class="form-wrap">
              <el-form size="mini" label-width="150px" label-suffix="：">
                <el-form-item label="计划指导人数" required>
                  <el-input-number v-model="form.planNum"
                                  :controls="false"
                                  :min="1"
                                  :precision="0"
                                  size="mini"></el-input-number>
                </el-form-item>
                <el-form-item label="允许申请人数" required>
                  <el-input-number v-model="form.applyNum"
                                  :controls="false"
                                  :min="1"
                                  :precision="0"
                                  size="mini"></el-input-number>
                </el-form-item>
                <el-form-item label="研究方向学术兴趣" required>
                  <el-input type="textarea" :rows="3" v-model="form.researchDirection" size="mini"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </AppScrollbar>
      </div>
      <div class="footer">
        <el-button size="mini" @click="handleCancel">取消</el-button>
        <el-button type="primary" size="mini" :loading="committing" @click="handleSubmit">{{committing ? '提交中...' : '提交'}}</el-button>
      </div>
    </template>
    <Hint v-else v-show="errorMsg">{{ errorMsg }}</Hint>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../../elements/AppScrollbar.vue'
import Hint from '../../../../../../../../elements/Hint.vue'
export default {
  name: 'PaperChoiceSetTeacherEdit',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      committing: false,
      errorMsg: '',
      teacherInfo: null,
      form: {
        planNum: undefined,
        applyNum: undefined,
        researchDirection: ''
      }
    }
  },
  methods: {
    handleCancel () {
      this.$emit('hidePopover')
    },
    loadData () {
      this.loading = true
      this.$ajax({
        method: 'post',
        url: '/workspace/manager/paper/choice/set/queryTeacherInfo',
        data: this.$qs.stringify({
          id: this.rowData.id
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.teacherInfo = response.data
        } else {
          this.errorMsg = response.data.message || '获取教师信息失败'
        }
      }, () => {
        this.errorMsg = '获取教师信息失败'
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const form = this.form
      if (!form.planNum) {
        this.$message.warning('请输入计划指导人数')
        return
      }
      if (!form.applyNum) {
        this.$message.warning('请输入允许申请人数')
        return
      }
      if (!form.researchDirection) {
        this.$message.warning('请输入研究方向学术兴趣')
        return
      }
      this.committing = true
      this.$ajax({
        method: 'post',
        url: '/workspace/manager/paper/choice/set/saveTeacherInfo',
        data: this.$qs.stringify(this.$extend({id: this.rowData.id}, form))
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.$message.success('保存成功')
          this.$emit('hidePopoverAndRefresh')
        } else {
          this.$message.error(response.data.message || '保存失败')
        }
      }, () => {
        this.$message.error('保存失败')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.loadData()
        } else {
          this.form = {
            planNum: undefined,
            applyNum: undefined,
            researchDirection: ''
          }
          this.teacherInfo = null
        }
      },
      immediate: true
    },
    teacherInfo: {
      handler (val) {
        if (val) {
          Object.keys(this.form).forEach(key => {
            if (key in val) {
              this.form[key] = val[key]
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.paper-choice-set-teacher-edit{
  height: 100%;
  display: flex;
  flex-direction: column;
  & > .cont-wrap{
    flex: 1;
    height: 0;
    padding: 20px 0;
    .cont{
      display: flex;
      & > .form-wrap{
        flex: 1;
        display: flex;
        justify-content: center;
        & + .form-wrap{
          border-left: 1px solid #e5e5e5;
        }
        ::v-deep  .el-form{
          .el-form-item{
            display: flex;
            justify-content: center;
            & > .el-form-item__label{
              font-size: 12px;
            }
            & > .el-form-item__content{
              flex: 1;
              font-size: 12px;
              margin-left: 0 !important;
              & > .el-input-number{
                width: 200px;
              }
              & > .el-textarea{
                width: 200px;
              }
            }
          }
        }
      }
    }
  }
  & > .footer{
    padding: 10px 0;
    text-align: center;
    background-color: #fff;
  }
}
</style>
